'use strict';

const TinCan = require('tincanjs');
const common = require('./common/functions');
const verb = require("../json/verb.json");

module.exports = {
    statement(membername, membercode, object, access_token, objectname)
    {

        membername = common.checkMembername(membername);

        return new TinCan.Statement({
                "actor": {
                    "objectType": "Agent",
                    "name": membername,
                    "account": {
                        "name": membername,
                        "homePage": "https://api.hkep.com/api/code/index.php/xapi/member?membercode='" + membercode + "'"
                    },
                    homepage: {
                        access_token: access_token,
                    },
                },
                "verb": {
                    "id": verb.suspend.url,
                    "display": {
                        "en-US": verb.suspend.en,
                        "zh-HK": verb.suspend.zh
                    }
                },
                "object": {
                    "objectType": "Activity",
                    "id": object,
                    "definition": {
                        "name": {
                            "zh-HK": (objectname)? objectname: object
                        },
                        "description": {
                            "zh-HK": (objectname)? objectname: object
                        }
                    }
                }
            }

        );

    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/xapijs/src/functions/Suspend.js
// module id = 3i0V
// module chunks = 2 3 4 5 6